export const quotesDashboardPath = () => '/reports/quotes-dashboard';

export const tssDashboardPath = () => '/reports/tss-dashboard';
